import { environment as baseEnvironment } from '../../../shared/src/environments/environment.qa';

export const environment = Object.assign(baseEnvironment, {
  cmsWebAppUrl: 'https://mindpop-webapp-website-qa.jad-sandbox.com/',
  cmsServerUrl: 'https://mindpop-api-website-qa.jad-sandbox.com/api/',
  idpServerUrl: 'https://mindpop-api-idp-qa.jad-sandbox.com/',
  stripePublicKey: 'pk_test_51RJxPBFPwBF4lpCSjHYGKnx1ALvQVAKFfkMgH8FYl1NtuP4dE5VA4HLlEzXCSnpDXPNUxp3ynSf9qF8XtT7WCxhj00cBWpzuWE',
  loginClientId: '6dbc5630-7dc7-44b7-be0c-235177534c6b'
});
